import { useState } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ProfileCard from "./components/ProfileCard";
import TicketsList from "./components/TicketsList";
import DrawTracker from "./components/DrawTracker";
import PurchaseHistory from "./components/PurchaseHistory";
import NotificationsPanel from "./components/NotificationsPanel";
import SettingsPanel from "./components/SettingsPanel";

type Tab = "tickets" | "draw" | "history" | "notifications" | "settings";

export default function Compte() {
  const [activeTab, setActiveTab] = useState<Tab>("tickets");

  const renderContent = () => {
    switch (activeTab) {
      case "tickets": return <TicketsList />;
      case "draw": return <DrawTracker />;
      case "history": return <PurchaseHistory />;
      case "notifications": return <NotificationsPanel />;
      case "settings": return <SettingsPanel />;
      default: return <TicketsList />;
    }
  };

  return (
    <main className="min-h-screen font-inter bg-slate-50">
      <Navbar />

      {/* Page Header */}
      <div className="bg-white border-b border-slate-100 pt-24 pb-6">
        <div className="max-w-7xl mx-auto px-6">
          <nav className="text-sm text-slate-400 mb-3" aria-label="Breadcrumb">
            <a href="/" className="hover:text-slate-600 cursor-pointer">Startseite</a>
            <span className="mx-2">/</span>
            <span className="text-slate-700 font-medium">Mein Konto</span>
          </nav>
          <h1 className="font-playfair text-3xl font-bold text-slate-900">
            Mein persönlicher Bereich
          </h1>
          <p className="text-slate-500 text-sm mt-1">
            Verwalten Sie Ihre Lose, verfolgen Sie die Ziehung #52 und sehen Sie Ihren Verlauf ein.
          </p>
        </div>
      </div>

      {/* Main Layout */}
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex flex-col lg:flex-row gap-8 items-start">
          {/* Sidebar */}
          <ProfileCard activeTab={activeTab} onTabChange={(tab) => setActiveTab(tab as Tab)} />

          {/* Content Area */}
          <div className="flex-1 min-w-0">
            {renderContent()}
          </div>
        </div>
      </div>

      <Footer />
    </main>
  );
}
